import { CODE_TEMPLATE, COMMENTS, IMMEDIATE_CODE_TEMPLATE } from './constants';
import { jsonToSchema, convertObject2Array } from './util';
export default {
    '@init': function (_a) {
        var data = _a.data, setAutoRun = _a.setAutoRun, isAutoRun = _a.isAutoRun, output = _a.output;
        var autoRun = isAutoRun ? isAutoRun() : false;
        if (autoRun || data.runImmediate) {
            setAutoRun(true);
            data.runImmediate = true;
            output.get('output0').setSchema({ type: 'number' });
        }
        data.fns = data.fns || (data.runImmediate ? IMMEDIATE_CODE_TEMPLATE : CODE_TEMPLATE);
    },
    '@inputConnected': function (_a, fromPin) {
        var data = _a.data, output = _a.output;
        if (data.fns === CODE_TEMPLATE) {
            output.get('output0').setSchema({ type: 'unknown' });
        }
    },
    ':root': [
        {
            title: '添加输入项',
            type: 'Button',
            ifVisible: function (_a) {
                var data = _a.data;
                return !data.runImmediate;
            },
            value: {
                set: function (_a) {
                    var input = _a.input;
                    var idx = getIoOrder(input);
                    var hostId = "input.inputValue".concat(idx);
                    var title = "\u53C2\u6570".concat(idx);
                    input.add(hostId, title, { type: 'follow' }, true);
                }
            }
        },
        {
            title: '添加输出项',
            type: 'Button',
            value: {
                set: function (_a) {
                    var output = _a.output;
                    var idx = getIoOrder(output);
                    var hostId = "output".concat(idx);
                    var title = "\u8F93\u51FA\u9879".concat(idx);
                    output.add({
                        id: hostId,
                        title: title,
                        schema: {
                            type: 'unknown'
                        },
                        editable: true,
                        deletable: true
                    });
                }
            }
        },
        {
            type: 'code',
            options: function (_a) {
                var data = _a.data, output = _a.output;
                var option = {
                    babel: true,
                    comments: COMMENTS,
                    theme: 'light',
                    minimap: {
                        enabled: false
                    },
                    lineNumbers: 'on',
                    eslint: {
                        parserOptions: {
                            ecmaVersion: '2020',
                            sourceType: 'module'
                        }
                    },
                    autoSave: false,
                    // onBlur: () => {
                    // 	updateOutputSchema(output, data.fns);
                    // }
                };
                return option;
            },
            title: '代码编辑',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.fns;
                },
                set: function (_a, fns) {
                    var data = _a.data;
                    data.fns = fns;
                }
            }
        }
    ]
};
function updateOutputSchema(output, code) {
    var outputs = {};
    var inputs = {};
    output.get().forEach(function (_a) {
        var id = _a.id;
        outputs[id] = function (v) {
            try {
                var schema = jsonToSchema(v);
                output.get(id).setSchema(schema);
            }
            catch (error) {
                output.get(id).setSchema({ type: 'unknown' });
            }
        };
    });
    setTimeout(function () {
        try {
            var fn = eval(decodeURIComponent(code.code || code));
            fn({
                inputValue: void 0,
                outputs: convertObject2Array(outputs),
                inputs: convertObject2Array(inputs),
                env: {
                    executeSql: function (sql) { return ({ rows: [] }); },
                    genUniqueId: function () { return Date.now(); },
                    getEntityName: function (_) { return _; },
                    encrypt: function (_) { return _; },
                    decrypt: function (_) { return _; },
                },
            });
        }
        catch (error) {
            console.error(error);
        }
    });
}
function getIoOrder(io) {
    var ports = io.get();
    var id = ports.pop().id;
    return Number(id.replace(/\D+/, '')) + 1;
}
